import { sendNotification } from './sendNotification'

export const catchUpdateNotification = (messageToLog: string) => {
  const text = 'Update request was failed. Please validate your data correctness'
  sendNotification(text, messageToLog)
}
